<template>
  <div v-bind:class="{'download-app-icon-box':true,'show-down-box':showDownBox}">
    <div class="touch-icon-box" ondragstart="return false;">
      <div class="touch-icon-app" ref="touchIconApp">
        <div v-bind:class="{'icon-app':true,'icon-app-animate':showAnimate}"></div>
      </div>
      <transition>
        <div class="icon-tips" v-show="showTips" ref="iconTips"></div>
      </transition>
    </div>
    <div
      v-bind:class="{'arrow-icon':true,'arrow-icon-animate':showAnimate}"
      v-clickMusic
      @touchstart="showIconApp"
      @mousedown="showIconApp"
      ondragstart="return false;"
      ref="arrowIcon"
    ></div>
    <v-mask style="background:none;" v-if="showDragMask"></v-mask>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import preload from "@/utils/preload";
import soundManager from "@/utils/soundManager";
import store from "@/store/index";
export default {
  name: "downLoadApp",
  components: {
    "v-mask": vmask
  },
  props: {},
  data() {
    return {
      showDragMask: false,
      timer: null,
      showDownBox: false,
      showAnimate: false,
      draggie: null,
      showTips: true,
      dragSide: true,
      initedDrag: false,
      imgUrls: [
        require("@/assets/img/app/UI_shouji_BG_01.png"),
        require("@/assets/img/app/UI_shouji_AP_01.png"),
        require("@/assets/img/app/UI_shouji_AZ_android_1280.png"),
        require("@/assets/img/app/UI_shouji_AZ_ios1280.png"),
        require("@/assets/img/app/UI_shouji_title_01.png"),
        require("@/assets/img/app/UI_shouji_BG_03.png"),
        require("@/assets/img/app/UI_shouji_APR_01.png"),
        require("@/assets/img/app/UI_shouji_saomiao_01.png"),
        require("@/assets/img/app/UI_shouji_button_02.png"),
        require("@/assets/img/app/UI_shouji_buttonA_02.png"),
        require("@/assets/img/app/UI_shouji_button_01.png"),
        require("@/assets/img/app/UI_shouji_buttonA_01.png"),
        require("@/assets/img/app/UI_shouji_buttonP_01.png")
      ]
    };
  },
  mounted() {
    new preload(this.imgUrls);
    this.$refs.iconTips.addEventListener("animationend", () => {
      this.showTips = false;
    });
    this.$refs.iconTips.addEventListener("webkitTransitionEnd", () => {
      this.showTips = false;
    });
    this.$refs.touchIconApp.addEventListener("animationend", () => {
      this.initDrag();
      this.redrawAppIcon();
    });
    this.$refs.touchIconApp.addEventListener("webkitTransitionEnd", () => {
      this.initDrag();
      this.redrawAppIcon();
    });
  },
  methods: {
    redrawAppIcon() {
      if (!this.showDownBox) {
        this.$nextTick(() => {
          this.$refs.touchIconApp.style.height = "0.42rem";
          this.$refs.touchIconApp.style.width = "0.215rem";
        });
      }
    },
    startTimer() {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.draggie.disable();
        this.showDownBox = false;
        this.clearTimer();
      }, 4 * 1000);
    },
    clearTimer() {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
    },
    showIconApp() {
      this.$refs.touchIconApp.style.height = "0.51rem";
      this.$refs.touchIconApp.style.width = "0.51rem";
      this.$nextTick(() => {
        this.showDownBox = true;
        this.showAnimate = true;
        this.startTimer();
        this.draggie.enable();
      });
    },
    initDrag() {
      if (this.initedDrag) {
        return;
      }
      this.initedDrag = true;
      this.draggie = new window.Draggabilly(".touch-icon-app", {
        containment: "#body"
      });
      this.draggie.disable();
      this.draggie.on("dragStart", () => {
        this.showDragMask = true;
        this.$refs.touchIconApp.style.height = "0.51rem";
        this.$refs.touchIconApp.style.width = "0.51rem";
        this.$nextTick(() => {
          if (!this.showDownBox) {
            this.showDownBox = true;
          }
        });
      });
      this.draggie.on("dragMove", () => {
        this.dragSide = false;
        this.clearTimer();
        this.$emit("move");
      });
      this.draggie.on("dragEnd", (event, position) => {
        this.showDragMask = false;
        const h1 = window
            .getComputedStyle(this.$refs.arrowIcon, null)
            .height.split("px")[0],
          h2 = window
            .getComputedStyle(this.$refs.touchIconApp, null)
            .height.split("px")[0],
          h = (h2 - h1) / 2;
        this.$refs.arrowIcon.style.top = position.y + h + "px";
        this.$refs.arrowIcon.style.bottom = "auto";
        if (this.dragSide == true) {
          this.showDownBox = false;
        }
      });
      this.draggie.on("contained", () => {
        this.dragSide = true;
        this.showDragMask = false;
      });
      this.draggie.on("staticClick", () => {
        this.clearTimer();
        new soundManager().playEffect(1000, "click");
        this.$emit("notice");
        store.dispatch("setCloseAllPopUp", "downLoadApp");
      });
    },
    showDownLoadApp() {
      this.showHowDownLoadApp = true;
    },
    handleClose() {
      this.showHowDownLoadApp = false;
    },
    closePop() {
      if (this.dragSide) {
        this.startTimer();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes iconAppDefault {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  10% {
    -webkit-transform: scale(1.3);
    transform: scale(1.3);
  }
  20% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }
  30% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-0.51rem, 0);
  }
}

@keyframes iconAppHide {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(-0.51rem, 0);
  }
}

@keyframes iconAppShow {
  from {
    transform: translate(-0.51rem, 0);
  }
  to {
    transform: translate(0, 0);
  }
}

@keyframes iconTipsHide {
  from {
    transform: translate(0.4rem, 0);
    opacity: 1;
  }
  to {
    transform: translate(0, 0);
    opacity: 0;
  }
}

@keyframes iconArrowShow {
  from {
    transform: translate(-0.215rem, 0);
  }
  to {
    transform: translate(0, 0);
  }
}

@keyframes iconArrowHide {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(-0.215rem, 0);
  }
}

.download-app-icon-box {
  &.show-down-box {
    .touch-icon-box {
      .icon-app-animate {
        transform: translate(-0.51rem, 0);
        -webkit-animation: iconAppShow 0.2s;
        animation: iconAppShow 0.2s;
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
      }
    }
    .arrow-icon-animate {
      transform: translate(0, 0);
      -webkit-animation: iconArrowHide 0.2s;
      animation: iconArrowHide 0.2s;
      -webkit-animation-delay: 0s;
      animation-delay: 0s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }
  .touch-icon-box {
    .touch-icon-app {
      position: fixed;
      z-index: 304;
      transform: translate(0, 0);
      bottom: 0;
      width: 0.51rem;
      height: 0.51rem;
      display: block;
    }
    .icon-app {
      width: 0.51rem;
      height: 0.51rem;
      display: block;
      background-image: url(~@/assets/img/app/UI_shouji_icon_01.png);
      background-repeat: no-repeat;
      background-size: cover;
      position: absolute;
      transform: translate(0, 0);
      bottom: 0;
      z-index: 5;
      -webkit-animation: iconAppDefault 1s;
      animation: iconAppDefault 1s;
      -webkit-animation-delay: 4s;
      animation-delay: 4s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }

    .icon-app-animate {
      width: 0.51rem;
      height: 0.51rem;
      display: block;
      background-image: url(~@/assets/img/app/UI_shouji_icon_01.png);
      background-repeat: no-repeat;
      background-size: cover;
      position: absolute;
      z-index: 5;
      transform: translate(-0.51rem, 0);
      -webkit-animation: iconAppHide 0.2s;
      animation: iconAppHide 0.2s;
      -webkit-animation-delay: 0s;
      animation-delay: 0s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }

    .icon-tips {
      width: 0.475rem;
      height: 0.37rem;
      display: block;
      z-index: 303;
      background-image: url(~@/assets/img/app/UI_shouji_icon_02.png);
      background-size: cover;
      position: absolute;
      transform: translate(0.4rem, 0);
      bottom: 0.071rem;
      -webkit-animation: iconTipsHide 0.5s;
      animation: iconTipsHide 0.5s;
      -webkit-animation-delay: 4s;
      animation-delay: 4s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }
  .arrow-icon {
    width: 0.215rem;
    height: 0.42rem;
    display: block;
    background-image: url(~@/assets/img/app/UI_shouji_icon_03.png);
    background-size: cover;
    position: absolute;
    transform: translate(-0.215rem, 0);
    bottom: 0.045rem;
    z-index: 555;
    -webkit-animation: iconArrowShow 0.5s;
    animation: iconArrowShow 0.5s;
    -webkit-animation-delay: 5s;
    animation-delay: 5s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    cursor: pointer;
  }
  .arrow-icon-animate {
    width: 0.215rem;
    height: 0.42rem;
    display: block;
    background-image: url(~@/assets/img/app/UI_shouji_icon_03.png);
    background-size: cover;
    position: absolute;
    bottom: 0.045rem;
    transform: translate(-0.215rem, 0);
    -webkit-animation: iconArrowShow 0.2s;
    animation: iconArrowShow 0.2s;
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
}
@media all and (orientation: portrait) {
  .download-app-icon-box {
    display: none;
  }
}
</style>